<!-- SwipFx Orders Page (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">
  <app-header [page]="'Admin'"></app-header>
  <main class="container py-4">

    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h4 class="fw-bold mb-0">Policy Documents</h4>
        <div class="text-muted small">
          Configure the document requirements users must upload
        </div>
      </div>

      <div class="d-flex gap-2">
        <button class="btn btn-outline-primary" type="button" (click)="openFields()">
          Manage Fields
        </button>

        <button class="btn btn-outline-primary" type="button" (click)="openRules()">
          Manage Rules
        </button>

        <button class="btn btn-outline-secondary btn-sm" (click)="back()">
          Back to Policy
        </button>
      </div>
    </div>

    <div class="card shadow-sm border-0 mb-4" *ngIf="policy">
      <div class="card-body">
        <div class="row g-3 small">
          <div class="col-md-4">
            <div class="text-muted">Policy</div>
            <div class="fw-semibold">{{ policy.name }}</div>
          </div>
          <div class="col-md-2">
            <div class="text-muted">Tier</div>
            <div class="fw-semibold">{{ policy.tierCode }}</div>
          </div>
          <div class="col-md-3">
            <div class="text-muted">Jurisdiction</div>
            <div class="fw-semibold">{{ policy.jurisdictionName }}</div>
          </div>
          <div class="col-md-3">
            <div class="text-muted">Version</div>
            <div class="fw-semibold">{{ policy.version }}</div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="loading" class="text-center py-4">
      <div class="spinner-border"></div>
    </div>

    <div *ngIf="error" class="alert alert-danger">
      {{ error }}
    </div>

    <form [formGroup]="importForm" (ngSubmit)="importDocuments()" class="card shadow-sm border-0 mb-4">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-start gap-3 flex-wrap mb-3">
          <div>
            <h5 class="mb-1">Import Documents</h5>
            <div class="text-muted small">
              Copy document requirements from another jurisdiction, tier, or policy into this policy.
            </div>
          </div>
        </div>

        <div class="row g-3 align-items-end">
          <div class="col-md-7">
            <label class="form-label">Source Policy</label>
            <select class="form-select" formControlName="sourcePolicyId">
              <option value="">Select source policy</option>
              <option *ngFor="let item of availableImportPolicies" [value]="item.id">
                {{ item.jurisdictionName || item.jurisdictionCode || item.jurisdictionId }} -
                {{ item.tierCode }} -
                {{ item.name }} v{{ item.version }}
              </option>
            </select>
            <div class="small text-danger mt-1" *ngIf="sourcePolicyId?.touched && sourcePolicyId?.invalid">
              Source policy is required.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label d-block">Existing Documents</label>
            <div class="form-check form-switch mt-2">
              <input class="form-check-input" type="checkbox" formControlName="overwriteExisting" />
              <label class="form-check-label">Overwrite matching document codes</label>
            </div>
          </div>

          <div class="col-md-2">
            <button class="btn btn-outline-primary w-100" type="submit" [disabled]="importing">
              <span *ngIf="importing" class="spinner-border spinner-border-sm me-2"></span>
              Import
            </button>
          </div>
        </div>
      </div>
    </form>

    <form [formGroup]="form" (ngSubmit)="save()" class="card shadow-sm border-0 mb-4">
      <div class="card-body">
        <h5 class="mb-3">{{ editingId ? 'Edit Document Requirement' : 'New Document Requirement' }}</h5>

        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label">Document Type Code</label>
            <input class="form-control" formControlName="documentTypeCode" placeholder="id_card" />
            <div class="small text-danger mt-1" *ngIf="documentTypeCode?.touched && documentTypeCode?.invalid">
              Document type code is required.
            </div>
          </div>

          <div class="col-md-4">
            <label class="form-label">Label</label>
            <input class="form-control" formControlName="label" placeholder="Government ID" />
            <div class="small text-danger mt-1" *ngIf="label?.touched && label?.invalid">
              Label is required.
            </div>
          </div>

          <div class="col-md-2">
            <label class="form-label">Min Files</label>
            <input class="form-control" type="number" min="0" formControlName="minFiles" />
          </div>

          <div class="col-md-2">
            <label class="form-label">Max Files</label>
            <input class="form-control" type="number" min="1" formControlName="maxFiles" />
          </div>

          <div class="col-md-2">
            <label class="form-label">Sort Order</label>
            <input class="form-control" type="number" min="0" formControlName="sortOrder" />
          </div>

          <div class="col-md-4">
            <label class="form-label">Accepted File Types</label>

            <select multiple class="form-select" formControlName="acceptedMimeTypes"
              (change)="onAcceptedMimeTypesChanged(form.value.acceptedMimeTypes)">

              <option *ngFor="let mime of mimeTypeOptions" [value]="mime.value">
                {{ mime.label }}
              </option>
            </select>

            <div class="form-text">
              Hold Cmd/Ctrl to select multiple file types.
            </div>

            <div class="mt-2 d-flex flex-wrap gap-1" *ngIf="form.value.acceptedMimeTypes?.length">
              <span class="badge text-bg-light border" *ngFor="let value of form.value.acceptedMimeTypes">
                {{ value }}
              </span>
            </div>

            <input type="hidden" formControlName="acceptedMimeTypesJson" />
          </div>

          <div class="col-md-2">
            <label class="form-label">Max File Size MB</label>
            <input class="form-control" type="number" min="0" formControlName="maxFileSizeMb" />
          </div>

          <div class="col-md-2">
            <label class="form-label d-block">Required</label>
            <div class="form-check form-switch mt-2">
              <input class="form-check-input" type="checkbox" formControlName="isRequired" />
              <label class="form-check-label">Yes</label>
            </div>
          </div>

          <div class="col-md-2">
            <label class="form-label d-block">Front & Back</label>
            <div class="form-check form-switch mt-2">
              <input class="form-check-input" type="checkbox" formControlName="requiresFrontAndBack" />
              <label class="form-check-label">Yes</label>
            </div>
          </div>

          <div class="col-md-2">
            <label class="form-label d-block">Expiry Date</label>
            <div class="form-check form-switch mt-2">
              <input class="form-check-input" type="checkbox" formControlName="requiresExpiryDate" />
              <label class="form-check-label">Yes</label>
            </div>
          </div>

          <div class="col-md-2">
            <label class="form-label d-block">Selfie Match</label>
            <div class="form-check form-switch mt-2">
              <input class="form-check-input" type="checkbox" formControlName="requiresSelfieMatch" />
              <label class="form-check-label">Yes</label>
            </div>
          </div>
        </div>

        <div class="mt-4 d-flex gap-2">
          <button class="btn btn-primary" type="submit" [disabled]="saving">
            <span *ngIf="saving" class="spinner-border spinner-border-sm me-2"></span>
            {{ editingId ? 'Update Document' : 'Create Document' }}
          </button>

          <button class="btn btn-outline-secondary" type="button" (click)="resetForm()">
            Clear
          </button>
        </div>
      </div>
    </form>

    <div *ngIf="!loading && !items.length" class="alert alert-light border">
      No policy documents found.
    </div>

    <div *ngIf="items.length" class="card shadow-sm border-0">
      <div class="table-responsive">
        <table class="table table-hover align-middle mb-0">
          <thead class="table-light">
            <tr>
              <th>Code</th>
              <th>Label</th>
              <th>Files</th>
              <th>Required</th>
              <th>Expiry</th>
              <th>Selfie</th>
              <th>Order</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let item of items">
              <td class="fw-semibold">{{ item.documentTypeCode }}</td>
              <td>{{ item.label }}</td>
              <td>{{ item.minFiles }} / {{ item.maxFiles }}</td>
              <td>{{ item.isRequired ? 'Yes' : 'No' }}</td>
              <td>{{ item.requiresExpiryDate ? 'Yes' : 'No' }}</td>
              <td>{{ item.requiresSelfieMatch ? 'Yes' : 'No' }}</td>
              <td>{{ item.sortOrder }}</td>
              <td class="text-end">
                <div class="d-inline-flex gap-2">
                  <button class="btn btn-sm btn-outline-primary" (click)="edit(item)">Edit</button>
                  <button class="btn btn-sm btn-outline-danger" [disabled]="deletingId === item.id"
                    data-bs-toggle="modal" data-bs-target="#deletePolicyDocumentModal" (click)="openDeleteModal(item)">
                    <span *ngIf="deletingId === item.id" class="spinner-border spinner-border-sm me-2"></span>
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <app-footer></app-footer>
  </main>
</div>

<div class="modal fade" id="deletePolicyDocumentModal" tabindex="-1" aria-labelledby="deletePolicyDocumentModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 shadow">
      <div class="modal-header">
        <h5 class="modal-title fw-semibold" id="deletePolicyDocumentModalLabel">Delete Policy Document</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          [disabled]="!!deletingId"></button>
      </div>

      <div class="modal-body">
        <div class="alert alert-warning py-2">
          This will remove the document requirement from this policy.
        </div>

        <div *ngIf="documentPendingDelete" class="border rounded p-3 bg-light-subtle">
          <div class="fw-semibold">{{ documentPendingDelete.label }}</div>
          <div class="text-muted small">{{ documentPendingDelete.documentTypeCode }}</div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" [disabled]="!!deletingId">
          Cancel
        </button>

        <button type="button" class="btn btn-danger" (click)="confirmDelete()"
          [disabled]="!!deletingId || !documentPendingDelete">
          <span *ngIf="!!deletingId" class="spinner-border spinner-border-sm me-2"></span>
          Delete Document
        </button>
      </div>
    </div>
  </div>
</div>